import React from 'react';
import './Tabs.sass';

import cx from 'classnames';

import ChannelLink from '../../containers/channelUtils/ChannelLink';

function Tab({component: Component = 'div', children, isActive, className, ...rest}) {
  return (
    <Component
      className={cx(className, 'tabs__item', isActive && 'is-active')}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default class Tabs extends React.PureComponent {
  render() {
    const {items, active, onChange, asLinks} = this.props;

    return (
      <div className="tabs">
        <div className="tabs__inner">
          {items.map(tab => (
            <Tab
              key={tab.value}
              isActive={tab.value === active}
              component={asLinks ? ChannelLink : 'div'}
              onClick={asLinks ? undefined : () => onChange(tab.value)}
              to={asLinks ? `/${tab.value}` : undefined}
            >
              {tab.name}
            </Tab>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/tabs/Tabs.js